import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import isEmpty from "lodash/isEmpty";
import {
  auth,
  googleAuthProvider,
} from "../../firebase/firebase";
import { getDocs } from "firebase/services/role";
import convertData from "firebase/utils/convertData";
import {
  SIGNIN_GOOGLE_USER,
  SIGNIN_USER,
  SIGNOUT_USER,
  SIGNUP_USER,
  GET_CURRENT_USER,
} from "constants/ActionTypes";
import {showAuthMessage, userSignInSuccess, userSignOutSuccess, userSignUpSuccess, getCurrentUserSuccess, userGoogleClosePopup} from "../../appRedux/actions/Auth";
import {resetStore} from "../../appRedux/actions/App";
import {
  userGoogleSignInSuccess,
} from "../actions/Auth";

const createUserWithEmailPasswordRequest = async (email, password) =>
  await  auth.createUserWithEmailAndPassword(email, password)
    .then(authUser => authUser)
    .catch(error => error);

const signInUserWithEmailPasswordRequest = async (email, password) =>
  await  auth.signInWithEmailAndPassword(email, password)
    .then(authUser => authUser)
    .catch(error => error);

const signOutRequest = async () => {
  try {
    await auth.signOut();
  } catch (e) {
    console.log('Sign out error', e);
  }
}

const signInUserWithGoogleRequest = async () =>
  await  auth.signInWithPopup(googleAuthProvider)
    .then(authUser => authUser)
    .catch(error => error);

function* createUserWithEmailPassword({payload}) {
  const {email, password} = payload;
  try {
    const signUpUser = yield call(createUserWithEmailPasswordRequest, email, password);
    if (signUpUser.message) {
      yield put(showAuthMessage(signUpUser.message));
    } else {
      localStorage.setItem('user_id', signUpUser.user.uid);
      yield put(userSignUpSuccess(signUpUser.user.uid));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* signInUserWithGoogle() {
  try {
    const signInUser = yield call(signInUserWithGoogleRequest);
    if (signInUser.message) {
      if (signInUser.message.includes('The popup has been closed by the user')) {
        yield put(userGoogleClosePopup());
      } else {
        yield put(showAuthMessage(signInUser.message));
      }
    } else {
      const { additionalUserInfo: { profile: { email, hd } } } = signInUser;
      if (!['younetgroup.com', 'buzzmetrics.com'].includes(hd)) {
        yield put(showAuthMessage('Email bắt buộc phải thuộc công ty: @younetgroup.com hoặc @buzzmetrics.com'));
        return;
      }
      const roles = yield call(getDocs, { filter: { email } });
      const convertedData = convertData(roles, true, true);
      if (isEmpty(convertedData)) {
        yield put(showAuthMessage('Email bạn nhập chưa được thêm vào hệ thống'));
        return;
      }
      const [data] = convertedData;
      localStorage.setItem('user_id', signInUser.user.uid);
      localStorage.setItem('role', isEmpty(data) ? 'member' : data.role);
      yield put(userGoogleSignInSuccess(signInUser.user.uid));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* signInUserWithEmailPassword({payload}) {
  const {email, password} = payload;
  try {
    const signInUser = yield call(signInUserWithEmailPasswordRequest, email, password);
    if (signInUser.message) {
      yield put(showAuthMessage('Email hoặc mật khẩu không chính xác'));
    } else {
      const roles = yield call(getDocs, { filter: { email  } });
      const convertedData = convertData(roles, true, true);
      if (isEmpty(convertedData)) {
        yield put(showAuthMessage('Email bạn nhập chưa được thêm vào hệ thống'));
        return;
      }
      const [data] = convertedData;
      localStorage.setItem('user_id', signInUser.user.uid);
      localStorage.setItem('role', isEmpty(data) ? 'member' : data.role);
      yield put(userSignInSuccess(signInUser.user.uid));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* signOut() {
  try {
    const signOutUser = yield call(signOutRequest);
    if (signOutUser === undefined) {
      localStorage.removeItem('user_id');
      localStorage.removeItem('role');
      yield put(resetStore());
      yield put(userSignOutSuccess(signOutUser));
      window.location.href = '/signin';
    } else {
      yield put(showAuthMessage(signOutUser.message));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

function* getCurrentUserData({ params }) {
  try {
    if (params) {
      yield put(getCurrentUserSuccess(params.email || ''));
    }
  } catch (error) {
    yield put(getCurrentUserSuccess(''));
  }
}

export function* createUserAccount() {
  yield takeEvery(SIGNUP_USER, createUserWithEmailPassword);
}

export function* signInWithGoogle() {
  yield takeEvery(SIGNIN_GOOGLE_USER, signInUserWithGoogle);
}

export function* signInUser() {
  yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOut);
}

export function* getCurrentUser() {
  yield takeEvery(GET_CURRENT_USER, getCurrentUserData);
}

export default function* rootSaga() {
  yield all([fork(signInUser),
    fork(createUserAccount),
    fork(signInWithGoogle),
    fork(signOutUser),
    fork(getCurrentUser)]);
}
